import React from 'react'
import Type from '../Components/Typewrite';
import profile from '../images/profilepic.jpg'
import Connectionstab from './Connectionstab';
import { FaFilePdf } from 'react-icons/fa';

const HomeComponents = () => {
  return (
    <div className="min-h-screen flex items-center justify-center pt-20 px-4">
      <div className="max-w-7xl w-full mx-auto flex flex-col-reverse lg:flex-row items-center justify-between gap-12">

        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left space-y-8 animate-fadeInLeft">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-6xl font-bold font-serif text-white tracking-tight">
              Hi There! <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
            </h1>
            <h1 className="text-4xl md:text-6xl font-bold font-serif text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">
              I'M SARVADNYA AWAGHAD
            </h1>
          </div>

          <div className="text-2xl md:text-3xl font-bold text-purple-200 min-h-[60px]">
            <Type />
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="bg-white/5 backdrop-blur-sm p-4 rounded-full border border-white/10">
              <Connectionstab />
            </div>

            <a
              href="/resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-bold shadow-lg hover:shadow-purple-500/50 transition-all duration-300 transform hover:-translate-y-1 overflow-hidden"
            >
              <span className="relative z-10 flex items-center gap-2">
                <FaFilePdf /> View Resume
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-purple-700 to-pink-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </a>
          </div>
        </div>

        {/* Profile Image */}
        <div className="flex-1 flex justify-center lg:justify-end animate-fadeInRight">
          <div className="relative group w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96">
            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
            <img
              src={profile}
              alt="Sarvadnya Awaghad"
              className="relative w-full h-full rounded-full object-cover border-4 border-black/50 shadow-2xl transform transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>

      </div>
    </div>
  )
}

export default HomeComponents